import type { ConfirmationInstructions } from '@bb/domain/dist/types/AppointmentConfig';

export const areAppointmentInstructionsInvalid = (
  access: string,
  instructions: ConfirmationInstructions,
) => {
  switch (access) {
    case 'Key':
      if (!instructions.key?.details) return true;
      return false;
    case 'Lock Box':
      if (!instructions.lockbox?.code && !instructions.lockbox?.details) {
        return true;
      }
      return false;
    case 'Door Code':
      if (!instructions.doorcode?.code && !instructions.doorcode?.details) {
        return true;
      }
      return false;
    default:
      return false;
  }
};
